import Fields from '@components/fields'
const Signature = ({ disabled }) => {
  return (
    <>
      <Fields.Signature name="signature" disabled={disabled} />
    </>
  )
}

export default Signature
